export default "__VITE_ASSET__8e7cf709__"